var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg94(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8201_3389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.511719H17.0522V20.3652H0V0.511719Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8201_3389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57307 2.01172C2.91607 2.01172 1.54007 3.35372 1.50107 5.00872V15.7277C1.46507 17.4287 2.80507 18.8287 4.49007 18.8657H12.5731C14.2421 18.8057 15.5631 17.4287 15.5521 15.7327V6.83972L10.9181 2.01172H4.58507H4.57307ZM4.58507 20.3657H4.45907C1.94707 20.3117 -0.0529317 18.2237 0.00106828 15.7117V4.99072C0.0600683 2.50972 2.10807 0.511719 4.57007 0.511719H4.58807H11.2371C11.4411 0.511719 11.6361 0.594719 11.7781 0.741719L16.8441 6.01872C16.9771 6.15772 17.0521 6.34472 17.0521 6.53772V15.7277C17.0681 18.2367 15.1121 20.2757 12.5991 20.3657H4.58507Z",
    fill: "#0E0E0E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2976 7.48424H13.5436C11.7126 7.47924 10.2256 5.98724 10.2256 4.15924V1.25024C10.2256 0.836244 10.5616 0.500244 10.9756 0.500244C11.3896 0.500244 11.7256 0.836244 11.7256 1.25024V4.15924C11.7256 5.16324 12.5416 5.98124 13.5456 5.98424H16.2976C16.7116 5.98424 17.0476 6.32024 17.0476 6.73424C17.0476 7.14824 16.7116 7.48424 16.2976 7.48424Z",
    fill: "#0E0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14258 15.2002C7.72858 15.2002 7.39258 14.8642 7.39258 14.4502V8.40918C7.39258 7.99518 7.72858 7.65918 8.14258 7.65918C8.55658 7.65918 8.89258 7.99518 8.89258 8.40918V14.4502C8.89258 14.8642 8.55658 15.2002 8.14258 15.2002Z",
    fill: "#0E0E0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14125 15.1992C7.94225 15.1992 7.75025 15.1202 7.61025 14.9782L5.26525 12.6242C4.97325 12.3302 4.97425 11.8552 5.26725 11.5632C5.56125 11.2712 6.03625 11.2712 6.32825 11.5652L8.14125 13.3872L9.95425 11.5652C10.2463 11.2712 10.7213 11.2712 11.0153 11.5632C11.3083 11.8552 11.3093 12.3302 11.0173 12.6242L8.67225 14.9782C8.53225 15.1202 8.34025 15.1992 8.14125 15.1992Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg94);
export default __webpack_public_path__ + "static/media/svg94.288f6faa04b8c27d657400d61146b863.svg";
export { ForwardRef as ReactComponent };